import * as React from 'react';

export default class ListItemActionComponent extends React.Component {
  render() {
    return (
      <span className="list-item-action">
        <button
        className="material-icons"
        onClick={this.props.onClick}
        title={this.props.title}>
          {this.props.icon}
        </button>
      </span>
    );
  }
}


// WEBPACK FOOTER //
// ./src/component/list/list-item-action/list-item-action-component.js